import React from 'react';

const KycStartedPage = () => {
  return <div></div>;
};

export default KycStartedPage;
